import getDeepLinkFn from '@kk/deeplink';
import globalData from '@kk-activity-factory/global-data';
import { getCurrentCommonActivityHtmlString } from './getCurrentCommonActivityHtmlString';

/**
 * 生成页面的deeplink
 * @param {Object} options
 * @param {string} options.el 绑定的按钮选择器
 * @param {string} options.title 页面标题
 * @param {string} options.activityMark 活动标识
 * @param {string} options.pageId 页面id
 * @param {string} [options.color] 页面背景色
 * @param {Object} [options.urlParam] 追加参数
 * @param {number} [options.isAdsShow] 追加参数
 */
export function getDeepLink({
    el,
    title,
    activityMark,
    pageId,
    color = 'FFFFFF',
    urlParam = {},
    url,
    isAdsShow = 1,
}) {
    const ServiceName = `${activityMark}-${pageId}`;

    let paramStr = '';
    if (urlParam) {
        for (const key of Object.keys(urlParam)) {
            paramStr += `&${key}=${urlParam[key]}`;
        }
    }

    const visitsource = globalData.visitSource > 0 ? globalData.visitSource : 999;
    let target_web_url = '';
    if (url) {
        target_web_url = url;
    } else {
        target_web_url = `${transferLink(
            `${process.env.VUE_APP_DEEPLINNK_BASE_URL}`
        )}?conf2fullscreen=1&conf2scrollwhitearea=1&statusbar=0&x5=33&backgroundColor=${color}&id=${pageId}&visitsource=${visitsource}${paramStr}`;
    }
    console.info('deepLink target_web_url', target_web_url);

    getDeepLinkFn({
        el: el,
        mode:
            process.env.VUE_APP_HOST_ENV === 'production' ||
            process.env.VUE_APP_HOST_ENV === 'preview'
                ? 'live'
                : 'test',
        isAdsShow: isAdsShow,
        params: {
            action: {
                target_id: 1,
                target_title: title,
                target_web_url: target_web_url,
                action_type: 18,
            },
            //新版埋点，必填，否则无法生成短链，具体埋点字段详细信息，可参考底部链接-埋点文档
            trackingList: [
                {
                    //打开deeplink埋点，默认上报
                    PropertyEvent: 'OpenAppByDeepLink', //埋点事件名
                    ServiceType: 1, //default，0:其他；1：分享; 2：M站；3:渠道投放；4：短信召回， 备注：当值为1时，需上报分享埋点
                    ServiceName: ServiceName, //default，业务参数，产品用于区分各种目标页
                },
                {
                    //分享埋点，只有上面ServiceType为1时，才上报该埋点，否则不用
                    PropertyEvent: 'ShareOpenAPPDetailPage', //埋点事件名
                    ShareContentType: 2, //default  内容类型
                    SubType: -1, //default  子类型
                    SubjectID: ServiceName, //default
                    ShareWay: 1, //默认，取地址参数 => h5:1，图片：3
                },
            ],
        },
    }).then(
        (data) => {
            console.info('生成DeepLink链接成功 =====> ', data);
        },
        (err) => {
            console.info('生成DeepLink链接失败 =====> ', err.message);
        }
    );
}

function transferLink(url) {
    return url.replace('common-activity/index.html', getCurrentCommonActivityHtmlString());
}
